export default __webpack_public_path__ + "static/media/file-shield-alt.537ae583.svg";